const accent = {
    easy: ["Spanish", "Italian", "German", "Indian", "Cockney"],

    medium: ["Russian", "Dutch", "Birmingham", "Manchester"],

    hard: [
        "Irish",
        "New York",
        "New Jersey",
        "Ghanian",
        "Nigerian",
        "South African",
        "Jamaican",
        "French",
    ],
};
export default accent;
